// extracted by mini-css-extract-plugin
export default {"layout":"MainAdminLayout_layout__qtHIP","flexBox":"MainAdminLayout_flexBox__IkCe4","zoom":"MainAdminLayout_zoom__ayvQG"};